<app-ark-container
  [future]="dataObservable"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onSuccess)="onWatchlisttDataResolved($event[0])"
>
</app-ark-container>

<ng-template #loading>
  <ul
    nz-menu
    style="background: white; border: none; border-radius: 0px; width: 245px;"
  >
    <li nz-menu-item class="watchlist-menu-item" (click)="openWatchlistModal()">
      <va-icon isFontAwesome="true" [name]="faPlus" class="new-watchlist"></va-icon> Create New
      Watchlist
    </li>
    <li nz-menu-divider></li>
    <li
      *ngFor="let dummySection of [0, 1, 2, 3, 4]"
      style="padding: 0px 15px 0px 15px"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </ul>
</ng-template>
<ng-template #failure>
  <div class="error-container">
    <div class="error-msg">
      <va-icon isFontAwesome="true" [name]="faExclamationTriangle" class="info-icon"></va-icon>
      <span class="error-text">Watchlists could not be loaded</span>
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container">
    <div class="error-msg">
      <va-icon isFontAwesome="true" [name]="faExclamationTriangle" class="info-icon"></va-icon>
      <span class="error-text">Watchlists could not be loaded</span>
    </div>
  </div>
</ng-template>
<ng-template #success>
  <div class="wathclist-menu-container">
    <ul nz-menu class="watchlist-menu-header">
      <li
        nz-menu-item
        class="watchlist-menu-item"
        (click)="openWatchlistModal()"
      >
        <va-icon isFontAwesome="true" [name]="faPlus" class="new-watchlist"></va-icon> Create
        New Watchlist
      </li>
      <li nz-menu-divider style=" margin: 4px 0px 0px 0px;"></li>
    </ul>

    <!-- add tooltips to watchlists that have only current company as only ticker -->
    <div *ngIf="watchLists.length > 0">
      <ul nz-menu class="watchlist-menu-body">
        <ng-container *ngFor="let watch of watchLists">
          <!-- if current company is the only ticker in wl -->
          <li
            *ngIf="watch.only_ticker_in_w"
            [class.only-ticker-in-w]="watch.only_ticker_in_w"
            nz-tooltip
            nzTooltipTitle="You cannot remove the last company in the watchlist"
            nzTooltipPlacement="bottom"
            nz-menu-item
          >
            <label
              nz-checkbox
              nzDisabled
              nzValue="{{ watch.w_id }}"
              [(ngModel)]="watch.ticker_in_w"
              title="{{ watch.w_name }}"
            >
              <span>
                {{ watch.w_name | textEllipsis: 25 }}
              </span>
            </label>
          </li>

          <!-- esle  -->
          <li *ngIf="!watch.only_ticker_in_w" nz-menu-item>
            <label
              nz-checkbox
              nzValue="{{ watch.w_id }}"
              [(ngModel)]="watch.ticker_in_w"
              (ngModelChange)="updateWatchlist($event, watch)"
              title="{{ watch.w_name }}"
            >
              <span>
                {{ watch.w_name | textEllipsis: 25 }}
              </span>
            </label>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <!-- <app-watchlist-modal
    [(visible)]="isVisibleWatchlistModal"
    (onClose)="onCloseWatchlistModal()"
  ></app-watchlist-modal> -->
</ng-template>
<ng-template #successTemplate>
  <p style="margin: 0px;">
    <span (click)="dimissSnackBar()">
      <va-icon isFontAwesome="true"
        [name]="faTimes"
        style="float: right; color: lightgray;"
      ></va-icon>
    </span>
    <va-icon isFontAwesome="true"
      [name]="faCheck"
      style="padding-right: 10px; color: #36abad;"
    ></va-icon
    ><span>{{ message }}</span>
  </p>
</ng-template>
<ng-template #failureTemplate>
  <p style="margin: 0px;">
    <span (click)="dimissSnackBar()">
      <va-icon isFontAwesome="true"
        [name]="faTimes"
        style="float: right; color: lightgray;"
      ></va-icon>
    </span>
    <va-icon isFontAwesome="true"
      [name]="faExclamationTriangle"
      style="padding-right: 10px; color: red"
    ></va-icon
    ><span>{{ message }}</span>
  </p>
</ng-template>
<div></div>
